import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleParagraph1 } from '@cian/ui-kit';

import { InlineButton } from '../InlineButton';
import { NBSP } from '../../../../constants/symbols';
import { isAbExperiment } from '../../../../utils/abuse';
import { selectAbUseExperiments } from '../../../../selectors/selectAbUseExperiments';
import { FIND_REALTOR_FORM_START } from '../../../../constants/experiments';

export interface IChangePhoneProps {
  phone: string;

  onChangeClick(): void;
}

export const ChangePhone: React.FC<React.PropsWithChildren<IChangePhoneProps>> = ({ phone, onChangeClick }) => {
  const isNewFormStart = isAbExperiment(useSelector(selectAbUseExperiments), FIND_REALTOR_FORM_START, 'B');

  const text = isNewFormStart ? `Отправили его${NBSP}на${NBSP}` : 'Введите код, который мы отправили на номер ';

  return (
    <div>
      <ArticleParagraph1>
        {text}
        {phone}
      </ArticleParagraph1>
      <InlineButton onClick={onChangeClick}>Изменить номер</InlineButton>
    </div>
  );
};

ChangePhone.displayName = 'ChangePhone';
